import { render, staticRenderFns } from "./vendor-sents.vue?vue&type=template&id=11adfcda"
import script from "./vendor-sents.vue?vue&type=script&lang=js"
export * from "./vendor-sents.vue?vue&type=script&lang=js"
import style0 from "./vendor-sents.vue?vue&type=style&index=0&id=11adfcda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports